import type { Vec2 } from '@learnforge/demo-math/geometry';
import { parse, evaluate } from '@learnforge/demo-math/expr';

/**
 * Sample `f` across [x0, x1] into `n+1` points.
 * Non-finite results pass through — the curve layer breaks paths at them.
 */
export function sampleFn(f: (x: number) => number, x0: number, x1: number, n: number): Vec2[] {
  const pts: Vec2[] = [];
  for (let i = 0; i <= n; i++) {
    const x = x0 + ((x1 - x0) * i) / n;
    pts.push({ x, y: f(x) });
  }
  return pts;
}

/**
 * Compile an expression string (variable `x`) to a fast `(x: number) => number`.
 * Uses the demo-math expression engine.
 */
export function compileFn(source: string): (x: number) => number {
  const node = parse(source).node;
  return (x: number) => evaluate(node, { x });
}
